function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './WatermarkFooter.module.scss';
import I18n from '../I18n/I18n/I18n';
import WatermarkFooterLogo from './WatermarkFooterLogo';
import normalizeLocaleData from '../utils/i18n/normalizeLocaleData';
import en from './locales/WatermarkFooter.en.json';
import AdditionalIntl from '../I18n/AdditionalIntl/AdditionalIntl';
import MetadataContext from '../MetadataContext';
var NAMESPACE = '@dm/components.watermark-footer';
var MESSAGES = normalizeLocaleData(en, NAMESPACE);
function Footer(_ref) {
  var _ref$sitemap = _ref.sitemap,
    sitemap = _ref$sitemap === void 0 ? true : _ref$sitemap;
  var copyrightI18n = useMemo(function () {
    return {
      id: NAMESPACE + '.copyright',
      values: {
        year: new Date().getFullYear()
      }
    };
  }, []);
  var md = useContext(MetadataContext);
  var sitemapHref = useMemo(function () {
    return "".concat(md.contextURL, "app/sitemap?").concat(md.httpSessionAliasParamName, "=").concat(md.httpSessionAlias);
  }, [md]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement(WatermarkFooterLogo, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.copyright
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: copyrightI18n
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.links
  }, /*#__PURE__*/React.createElement("ul", null, sitemap && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: sitemapHref
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: NAMESPACE + '.sitemap'
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.watermarkinsights.com/terms/",
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: NAMESPACE + '.terms'
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.watermarkinsights.com/privacy-policy/",
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: NAMESPACE + '.privacy'
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.watermarkinsights.com/accessibility/",
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: NAMESPACE + '.accessibility'
  }))))));
}
export default function (_ref2) {
  var _ref2$container = _ref2.container,
    container = _ref2$container === void 0 ? document.body : _ref2$container,
    _ref2$includeBodyClas = _ref2.includeBodyClass,
    includeBodyClass = _ref2$includeBodyClas === void 0 ? true : _ref2$includeBodyClas,
    props = _objectWithoutProperties(_ref2, ["container", "includeBodyClass"]);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    el = _useState2[0],
    setEl = _useState2[1];
  useEffect(function () {
    var el = document.createElement('footer');
    el.setAttribute('id', 'wm-footer');
    el.classList.add(styles.container);
    if (includeBodyClass) {
      document.body.classList.add(styles.body);
    }
    container.append(el);
    setEl(el);
    return function () {
      document.body.classList.remove(styles.body);
      el.remove();
    };
  }, [container]);
  if (el) {
    return ReactDOM.createPortal(/*#__PURE__*/React.createElement(AdditionalIntl, {
      messages: MESSAGES,
      namespace: NAMESPACE,
      path: "WatermarkFooter/locales/WatermarkFooter"
    }, /*#__PURE__*/React.createElement(Footer, props)), el);
  }
  return null;
}